import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaPresencasColaboradoresLayer from "../components/ListaPresencasColaboradoresLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaPresencasColaboradoresPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("presencaColab.breadcrumb")} />
      <ListaPresencasColaboradoresLayer />
    </MasterLayout>
  );
};

export default ListaPresencasColaboradoresPage;
